import React from 'react'
import { AppBar, Toolbar, Box } from '@mui/material'
import LogoRv from '../../../../Assets/logo-rv-login.svg'

const Header: React.FC = () => {
    return (
        <AppBar
            position="static"
            sx={{
                borderBottom: '1px solid #eee',
                backgroundColor: 'var(--Contrast-Deep-Light, #fff)',
            }}
        >
            <Toolbar style={{ justifyContent:"center"}}>
                <Box
                    component="img"
                    src={LogoRv}
                    alt="Rv Logo"
                    sx={{
                        width: 64,
                        height: 64,
                        objectFit: 'contain'
                    }}
                />
            </Toolbar>
        </AppBar>
    )
}

export default Header
